import CONFIG from '../config/app-config';
import ApiManager from '../api/api-manager';

class StorySource {
  static async getAllStories(params = {}) {
    const url = new URL(ApiManager.buildUrl('/stories'));
    
    if (params.page) url.searchParams.append('page', params.page);
    if (params.size) url.searchParams.append('size', params.size);
    if (params.location) url.searchParams.append('location', params.location);

    const token = localStorage.getItem('heliaedu_token');
    const headers = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await ApiManager.request(url.href, { headers });
    
    return response;
  }

  static async getStoryDetail(id) {
    const token = localStorage.getItem('heliaedu_token');
    const headers = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await ApiManager.request(`/stories/${id}`, { headers });
    
    return response;
  }

  static async addStory(storyData) {
    const token = localStorage.getItem('heliaedu_token');
    
    const formData = new FormData();
    formData.append('description', storyData.description);
    formData.append('photo', storyData.photo);
    
    if (storyData.lat && storyData.lon) {
      formData.append('lat', storyData.lat);
      formData.append('lon', storyData.lon);
    }
  
    const endpoint = token ? '/stories' : '/stories/guest';
    const headers = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  
    const response = await ApiManager.request(endpoint, {
      method: 'POST',
      headers,
      body: formData,
    });

    return response;
  }

  static async login(email, password) {
    const response = await ApiManager.request('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    
    return response;
  }

  static async register(name, email, password) {
    const response = await ApiManager.request('/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email, password }),
    });
    
    return response;
  }

  static async subscribeToNotifications(subscriptionData) {
    
    const token = localStorage.getItem('heliaedu_token');
    
    if (!token) {
      throw new Error('Authentication required');
    }

    // Validasi subscription data
    if (!subscriptionData || !subscriptionData.endpoint || !subscriptionData.keys) {
      throw new Error('Invalid subscription data structure');
    }

    const { endpoint, keys } = subscriptionData;

    if (!keys.p256dh || !keys.auth) {
      throw new Error('Missing required subscription keys');
    }

    const apiUrl = '/notifications/subscribe';

    const requestBody = {
      endpoint: endpoint,
      keys: {
        p256dh: keys.p256dh,
        auth: keys.auth
      }
    };


    try {
      const response = await ApiManager.request(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      
      return response;
    } catch (error) {
      
      
      // Fallback untuk development jika API belum support
      if (error.message.includes('404') || error.message.includes('500') || error.message.includes('Failed to fetch')) {
        
        return { 
          error: false, 
          message: 'Success to subscribe (simulasi)',
          data: { id: 'local_' + Date.now() }
        };
      }
      throw error;
    }
  }

  static async unsubscribeFromNotifications(endpoint) {
    const token = localStorage.getItem('heliaedu_token');
    
    if (!token) {
      throw new Error('Authentication required');
    }

    if (!endpoint) {
      throw new Error('Endpoint is required for unsubscribe');
    }

    const apiUrl = '/notifications/subscribe';

    try {
      const response = await ApiManager.request(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ endpoint }),
      });
      
      return response;
    } catch (error) {
      
      
      // Fallback untuk development
      if (error.message.includes('404') || error.message.includes('500') || error.message.includes('Failed to fetch')) {
        
        return { 
          error: false, 
          message: 'Success to unsubscribe (simulasi)'
        };
      }
      throw error;
    }
  }
}
export default StorySource;
